import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';
import usePagination from '@mui/material/usePagination';
import PaginationIcon from './PaginationIcon.js';

const ICONS_TYPES = ['first', 'last', 'next', 'previous'];
const Root = styled(MuiBox) `
  display: flex;
  align-items: center;
  height: 36px;
  user-select: none;
  ${({ theme }) => `
    padding: ${theme.spacing(2)};
  `}
`;
const Label = styled(MuiTypography) `
  ${({ theme }) => `
    color: ${theme.palette.N30.main};
    margin-right: 16px;
  `}
`;
const IconsWrapper = styled(MuiBox) `
  display: flex;
`;
const Pagination = (_a) => {
    var { count, pageLabel = 'page', page, paginationHints } = _a, rest = __rest(_a, ["count", "pageLabel", "page", "paginationHints"]);
    const { items = [] } = usePagination(Object.assign({ count, page }, rest));
    const label = useMemo(() => {
        var _a;
        const currentPage = page || ((_a = items.find(item => item.selected)) === null || _a === void 0 ? void 0 : _a.page) || 1;
        return `${pageLabel} ${currentPage}/${count}`;
    }, [items, pageLabel, page, count]);
    const filteredIcons = useMemo(() => {
        return items
            .filter(item => ICONS_TYPES.includes(item.type))
            .map(item => (jsx(PaginationIcon, Object.assign({}, item, { hint: paginationHints ? paginationHints[item.type] : '' }), item.type)));
    }, [items, paginationHints]);
    return (jsxs(Root, { children: [jsx(Label, Object.assign({ variant: "subtitle2" }, { children: label })), jsx(IconsWrapper, { children: filteredIcons })] }));
};

export { Pagination as default };
//# sourceMappingURL=Pagination.js.map
